import React, { useEffect } from 'react';
import { Accordion } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleChevronDown, faCircleChevronRight } from '@fortawesome/free-solid-svg-icons';

import PagesHeroSection from '../../components/pagesHeroSection/pagesHeroSection';
import SEOUpdater from '../../utils/hoc/SEOUpdater';
import './faqPage.scss';

const FaqPage = () => {
  const { t, i18n } = useTranslation('faq');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const categories = t('faq', { returnObjects: true });

  useEffect(() => {
    const mainEntity = Object.entries(categories).flatMap(([categoryKey, categoryValue]) =>
      Object.entries(categoryValue)
        .filter(([key]) => key.startsWith('q'))
        .map(([, question]) => ({
          '@type': 'Question',
          name: question.title,
          acceptedAnswer: {
            '@type': 'Answer',
            text: question.answer,
          },
        })),
    );

    const schema = {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity,
    };

    let script = document.querySelector('script[data-structured-data="faq"]');
    if (!script) {
      script = document.createElement('script');
      script.type = 'application/ld+json';
      script.setAttribute('data-structured-data', 'faq');
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(schema);

    return () => {
      script.remove();
    };

  }, [i18n.language]);

  return (
    <div className="faqPage">
      {/* Dynamic SEO metadata */}
      <SEOUpdater page="faq" />

      {/* Hero section */}
      <PagesHeroSection page="FAQ" />

      {/* Accordion Section */}
      <div className="immigration-faq">
        <Accordion defaultActiveKey="0">
          {Object.entries(categories).map(([categoryKey, categoryValue], index) => (
            <Accordion.Item eventKey={`${index}`} key={categoryKey}>
              <Accordion.Header>
                <FontAwesomeIcon icon={faCircleChevronDown} className="me-2" />
                {t(`faq.${categoryKey}.title`)}
              </Accordion.Header>

              <Accordion.Body>
                <Accordion>
                  {Object.entries(categoryValue)
                    .filter(([key]) => key.startsWith('q'))
                    .map(([qKey], subIndex) => (
                      <Accordion.Item eventKey={`${index}-${subIndex}`} key={qKey}>
                        {/* react-bootstrap's Accordion.Header renders an <h2> by
                            default (see AccordionHeader.js), and the outer,
                            category-level Accordion.Header above also renders an
                            <h2> - so with 27 categories and 273 questions, the
                            page shipped 300 headings all at the same rank, with
                            no way to tell a topic from its own question. `as="h3"`
                            only changes the rendered tag (the "accordion-header"
                            class and click behavior are unaffected), so each
                            question now nests correctly under its category
                            heading with zero visual change. */}
                        <Accordion.Header as="h3">
                          <FontAwesomeIcon icon={faCircleChevronRight} className="me-2" />
                          {t(`faq.${categoryKey}.${qKey}.title`)}
                        </Accordion.Header>

                        <Accordion.Body>
                          {t(`faq.${categoryKey}.${qKey}.answer`)
                            .split('\n')
                            .map((line, i) => (
                              <div key={i}>{line}</div>
                            ))}
                        </Accordion.Body>
                      </Accordion.Item>
                    ))}
                </Accordion>
              </Accordion.Body>
            </Accordion.Item>
          ))}
        </Accordion>
      </div>
    </div>
  );
};

export default FaqPage;
